import { useEffect, useState } from 'react'

import { getDesignMode, subscribeDesignMode, type DesignMode } from './store'

/**
 * The rendering the calling seam should serve, kept live.
 *
 * `useState` + `useEffect` rather than `useSyncExternalStore`: the runtime is
 * React 18 and has it, but this repo pins `@types/react` 17 (see the
 * `resolutions` block in package.json), which does not declare it — the hook
 * would not type-check. Tearing is not a concern for a value that changes when
 * a human clicks a button.
 *
 * The initialiser reads the persisted choice, so the FIRST render is already
 * correct: someone who has never touched the control renders antd with no
 * flash of anything else, and someone who picked "New design" renders shadcn
 * with no flash of antd.
 */
export const useDesignMode = (): DesignMode => {
  const [mode, setMode] = useState<DesignMode>(getDesignMode)

  useEffect(() => subscribeDesignMode(() => setMode(getDesignMode())), [])

  return mode
}
